import { Box, type BoxProps } from '@pets-ui/Box/Box'
import * as stylex from '@stylexjs/stylex'
import AquaLogo from './aqua-logo.svg?react'
import DcsLogo from './dcs-logo.svg?react'
import HmLogo from './hm-logo.svg?react'
import LmLogo from './lm-logo.svg?react'
import MnpLogo from './mnp-logo.svg?react'
import PmLogo from './pm-logo.svg?react'
import PpLogo from './pp-logo.svg?react'
import RsLogo from './rs-logo.svg?react'
import StmLogo from './stm-logo.svg?react'
import YtLogo from './yt-logo.svg?react'
export const logoMap = {
  DCS: DcsLogo,
  HM: HmLogo,
  LM: LmLogo,
  MNP: MnpLogo,
  AQUA: AquaLogo,
  PP: PpLogo,
  PM: PmLogo,
  YT: YtLogo,
  RS: RsLogo,
  STM: StmLogo,
}

interface LogoElectronicCommerceProps extends BoxProps {
  logo: keyof typeof logoMap
  width?: number
  height?: number
}

const styles = stylex.create({
  logo: {
    margin: '0 auto',
    display: 'block',
  },
})

export function LogoElectronicCommerce(props: LogoElectronicCommerceProps) {
  const { logo, width, height, ...rest } = props
  const Logo = logoMap[logo]
  return (
    <Box {...rest}>
      <Logo {...stylex.props(styles.logo)} width={width ? `${width}px` : '60px'} height={height ? `${height}px` : '60px'} />
    </Box>
  )
}
